import IconSocialMedia from './IconSocialMedia';

export default IconSocialMedia;
